<template>
  <div id="question-intro">
    <h3 class="q-text" v-html="question.text" ></h3>
    <div class="q-img-wraper">
      <img :src="question.image" :alt="question.text" @load="$emit('introImgHasLoaded')" />
    </div>
    <div class="q-invite-text">
      {{ question.inviteText }}
    </div>

    <div class="answers-list-block">
      <button
          v-for="(answer, key) in question.answers"
          :key="key"
          type="button"
          class="answer-btn"
          @click.stop="$emit('userHasAnswered', key)"
      >
        <span class="answer-icon"><i></i></span>
        <span class="answer-text">{{ answer.text }}</span>
      </button>
    </div>
    <div class="sources-list">
      <div>Источник:</div>
      <p
          v-for="(source, index) in question.sourcesList"
          :key="index"
          v-html="source"
      ></p>
    </div>
  </div>
</template>

<script>

export default {
  name: "QuestionIntro",
  data: () => ({}),
  emits:['userHasAnswered', 'introImgHasLoaded'],
  props: ['question'],
  components: {},
  methods: {}
}
</script>


<style scoped lang="scss">

</style>